'use strict';
import {EwSiteApp} from '../app/ewsiteapp';

EwSiteApp.controller('CommentsCtrl', ['$scope', '$http', '$attrs', '$log', function ($scope, $http, $attrs, $log) {
		$scope.postUrl = '';
		$scope.getUrl = '';
		$scope.hash_key = '';
		$scope.isconfirm = false;
		$scope.errors = [];
		$scope.comments = {
			list: []
		};
		$scope.all_displayed = false;

		$scope.clearCommentsForm = function () {
			$scope.comment.name = "";
			$scope.comment.email = "";
			$scope.comment.comment = "";
			$scope.errors = [];
			$scope.commentform.$setPristine();
		};

//jsonp -comentaru listui

		$scope.submit = function () {
			if ($scope.postUrl !== '') {
				$scope.isconfirm = false;
				$http({
					method: 'POST',
					url: $scope.postUrl + '?hash_key=' + $scope.hash_key,
					data: $scope.comment,
					xsrfCookieName: $scope.hash_key
				}).then(function (response) {
					if (response.data.data.success) {
						$scope.clearCommentsForm();
						$scope.isconfirm = response.data.data.isconfirm;
						if (!$scope.isconfirm) {
							$scope.getList(1);
						}
					} else if (angular.isDefined(response.data.data.messages)) {
//					$log.debug(data.data.message);
						$scope.errors = response.data.data.messages;
					}
					if (angular.isDefined(response.data.data.debug)) {
						$log.debug(response.data.data.debug);
					}
					if (!$scope.isconfirm) {
						$('html, body').animate({
							scrollTop: $(".comments_list").offset().top - 10
						}, 300);
					}
				}, function (response) {
					console.log(['Error', response]);
				});
			}
		};

		$scope.getList = function (getall) {
			if (getall == 1) {
				$scope.all_displayed = true;
			}
			if ($scope.getUrl !== '') {
				$http({
					method: 'GET',
					url: $scope.getUrl + '?getall=' + getall + ';hash_key=' + $scope.hash_key,
				}).then(function (response) {
					$scope.comments.list = response.data.list;
					if (getall == 0 && response.data.totalRows <= $scope.limit) {
						$scope.all_displayed = true;
					}
				}, function (response) {
					console.log(['Error', response]);
				});
			}
		};

		$scope.hasErrors = function () {
			return $scope.errors.length > 0;
		};




	}]).directive('commentsContainer', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.postUrl = '';
			scope.getUrl = '';
			scope.hash_key = '';
			scope.limit = 10;
			if (attr.postUrl !== '') {
				scope.postUrl = attr.postUrl;
			}
			if (attr.id !== '') {
				scope.hash_key = attr.id;
			}
			if (attr.limit !== '') {
				scope.limit = attr.limit;
			}
			if (attr.getUrl !== '') {
				scope.getUrl = attr.getUrl;
				scope.getList(0);
			}

		}
	};
});

EwSiteApp.controller('SuggestSearchCtrl', ['$scope', '$log', 'ajaxSearch', '$timeout', '$sce', function ($scope, $log, ajaxSearch, $timeout, $sce) {
		$scope.searchUrl = '';
		$scope.sdquery = '';
		$scope.searchresults = [];
		$scope.total = 0;
		$scope.search_url = '';
		$scope.inputTouched = false;
		$scope.templates = {
			title_description: 'search/title_description.html',
			img_title: 'search/img_title.html',
			img_title_description: 'search/img_title_description.html',
			module_gallery: 'search/module_gallery.html',
			module_youtubegallery: 'search/module_youtubegallery.html',
		};
		$scope.str_len = 100;
		// Move the highlightFilter function outside of the controller
		function highlightFilter(text, search) {
			if (!search) {
				return $sce.trustAsHtml(text);
			}
			return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<span class="highlight">$&</span>'));
		}

		// Expose the function to the $scope
		$scope.highlightFilter = highlightFilter;
		$scope.find = function () {
			if ($scope.searchUrl !== '') {
				$timeout(function () {
					$scope.inputTouched = true;
				}, 500);
				ajaxSearch.search($scope.searchUrl, {sdquery: $scope.sdquery}).then(function (results) {
					if ($scope.sdquery === '') {
						$scope.clear();
					} else {
						$scope.displaySuggestions(results);
						$scope.total = results.total;
//						$scope.search_url = results.search_url;
						$scope.search_url = results.eso_prod_search_url;

					}
				}, function (response) {
					$log.error(response);
				});
			}

		};
		$scope.displaySuggestions = function (results) {
			$scope.searchresults = results.data;
		};
		$scope.clear = function () {
			$scope.sdquery = '';
			$scope.total = 0;
			$scope.displaySuggestions([]);
		};
		$scope.getDataTemplate = function (data) {
			if (data.module === 'gallery' || data.module === 'photoalbums') {
				data.display_options.template.id = 'module_gallery';
			}
			if (data.module === 'youtubegallery') {
				data.display_options.template.id = 'module_youtubegallery';
			}
			if (typeof (data.display_options.template.id) !== 'undefined' && typeof ($scope.templates[data.display_options.template.id]) !== 'undefined') {
				return $scope.templates[data.display_options.template.id];
			}
			return $scope.templates.title_description;
		};
		$scope.changeLocationHash = function (data, name, varname) {
			var hash = '!' + name + data.display_options.vars[varname];
			location.hash = hash;
		};
	}]).directive('suggestSearchContainer', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.searchUrl = '';
			if (attr.searchUrl !== '') {
				scope.searchUrl = attr.searchUrl;
			}
		}
	};
});

//Eucookie
EwSiteApp.controller('EuCookieCtrl', ['$scope', '$http', '$attrs', '$log', function ($scope, $http, $attrs, $log) {
		$scope.data = {};
		$scope.state = 0;
		$scope.pop = false;
		$scope.showLine = true;
		$scope.message = '';
		$scope.loading = false;
		$scope.error = false;

		$scope.hiddeLine = function () {
			$scope.showLine = !$scope.showLine;
		};
		$scope.closePopup = function () {
			$scope.pop = false;
		};
		$scope.showPop = function () {
			$scope.pop = !$scope.pop;
		};

		$scope.storeChoises = function () {
			$scope.loading = true;
			$http({
				method: 'POST',
				url: unescape($attrs.storeUrl),
				data: $scope.data,
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (typeof (response.data.message) !== 'undefined' && response.data.message) {
					$scope.message = response.data.message;
					$scope.loading = false;

					$scope.hiddeLine();
					document.querySelector("body.cookies-not-activated").classList.remove("cookies-not-activated");
					document.querySelector("#eucookie_dialog").classList.add("activated");
				} else {
					$scope.error = true;
					$scope.loading = false;
				}
				if (typeof (response.data.reload) !== 'undefined' && response.data.reload) {
					reloadPage();
				}
				if (typeof (response.data.collection) !== 'undefined') {
					loadCollection(response.data.collection);
				}
			}, function (response) {
				$scope.hiddeLine();
				document.querySelector("body.cookies-not-activated").classList.remove("cookies-not-activated");
				document.querySelector("#eucookie_dialog").classList.add("activated");
				console.log(['Error', response]);
			});
		};

		$scope.initPopUp = function () {
			$scope.showLine = true;
		};

		$scope.storeAllChoises = function () {
			$scope.data.privacy_2 = true;
			$scope.data.privacy_3 = true;
			$scope.data.privacy_4 = true;
			$scope.storeChoises();
		};

		function loadCollection(collection) {
			let ifr = document.createElement('iframe');
			ifr.style.display = 'none';
			document.body.appendChild(ifr);
			if (typeof (collection.head) !== 'undefined' && collection.head.length > 0) {
				for (let bl of collection.head) {
					ifr.contentDocument.head.innerHTML += bl;
				}
				for (let nod of ifr.contentDocument.head.childNodes) {
					if (nod.nodeType !== 1) {
						continue;
					}
					let ss = document.createElement(nod.tagName);
					for (let att of nod.attributes) {
						ss.setAttribute(att.nodeName, att.nodeValue);
					}
					ss.innerText = nod.innerText;
					document.head.appendChild(ss);
				}
			}
			document.body.removeChild(ifr);
		}

		function reloadPage() {
			location.reload();
		}
	}]);

//Registerfault
EwSiteApp.controller('RegisterfaultFormCtrl', ['$scope', '$sce', '$filter', '$http', '$log', 'ajaxSearch', function ($scope, $sce, $filter, $http, $log, ajaxSearch) {

		$scope.forms = jsRegisterFault.forms;
		$scope.default_questions = jsRegisterFault.questions;
		$scope.questions = jsRegisterFault.questions;
		$scope.questions_svyruoja = jsRegisterFault.questions_svyruoja;
		$scope.questions_el_saitiklio = jsRegisterFault.questions_el_saitiklio;
		$scope.getIconPath = function (form) {
			if (form.image) {
				return form.image;
			}
			return theme_path + form.icon;
		};

		$scope.findUrl = jsRegisterFault.findUrl;
		$scope.postUrl = jsRegisterFault.submitUrl;//jsRegisterFault.submitUrl

		$scope.trySubmit = false;
		$scope.loading = false;
		$scope.submited = false;
		$scope.messages = [];
		$scope.addresses = [];
		$scope.showSuggest = false;

		$scope.phoneNumberPattern = /^(\+*)[0-9\s]{9,14}$/;
		$scope.phoneNumberPatternInt = /^\d{7}$/;
		$scope.emailPattern = /^.+@[^@;!`~#$%\^&*\(\)=+]{2,}\.[a-z]{2,6}$/;
		$scope.housePattern = /^[0-9]/;

		function getDefaultData() {
			return {
				recaptchaResponse: null,
				address: '',
				address_id: null,
				house: '',
				appartment: '',
				phone: '',
				email: '',
				comment: '',
				category: ''
			};
		}
		$scope.formData = getDefaultData();

		$scope.displayStatus = 0;
		$scope.id = 0;
		$scope.allAnswersRendered = false;
		$scope.progressVal = 0;
		$scope.displayProgress = false;
		$scope.resultsPage = false;
		$scope.situation_title = '';
//	$scope.number_bad_searches = 0;
//	$scope.limit_bad_searches = 3;
		$scope.bad_address_length = 5;
		$scope.show_bad_searches = false;
		$scope.back_to_question = false;
		$scope.back_question_id = null;

		var cont = document.querySelector('.main-layout');
		var header = document.querySelector('.header-container');


		$scope.setDisplayStatus = function (status) {
			let category_id = '';
			if (arguments[1]) {
				category_id = arguments[1];
			}
			document.querySelector('.index_container').scrollIntoView({
				behavior: 'smooth'
			});
			if (status > 0 && category_id != '') {//category_id!=''
				$scope.situation_title = jsRegisterFault.forms[category_id].title;
			}
			if (status == 0) {
				$scope.situation_title = '';
			}
			$scope.displayStatus = status;
			$scope.setdisplayProgress(true);
			if (category_id != '') {
				$scope.formData.category = category_id;
				$scope.formParams = jsRegisterFault.forms[$scope.formData.category];
				if ($scope.formData.category == 'pavojingamano' || $scope.formData.category == 'pavojinganemano' || $scope.formData.category == 'kita') {
					$scope.displayStatus = 99;
					$scope.setdisplayProgress(false);
					$scope.progressVal = '100';
				}
				if ($scope.formData.category == 'svyruojaitampa') {
					$scope.questions = $scope.questions_svyruoja;
				}
				if ($scope.formData.category == 'elektrosskaitiklio') {
					$scope.questions = $scope.questions_el_saitiklio;
				}
			}
			/*if ( status == 1 ){
			 fixView();
			 }*/
		};


		$scope.setdisplayProgress = function (val) {
			$scope.displayProgress = val;
		};

		$scope.stepBack = function (btn) {
			if (btn.back_id >= 0) {
				btn.question_id = btn.back_id;
				if (typeof btn.back_question_id !== 'undefined' && btn.back_question_id > 0) {
					btn.question_id = btn.back_question_id;
					btn.back_question_id = null;
				}
				$scope.getCurrentQuestions(btn);
			} else {
				$scope.questions = $scope.default_questions;
				$scope.setDisplayStatus(0);
			}
		};

		$scope.backToQuestion = function (question_id) {
			$scope.displayStatus = 1;
			$scope.submited = false;
			for (var i = 0, len = $scope.questions.length; i < len; i++) {
				if ($scope.questions[i].id == question_id) {
					$scope.id = question_id;
					$scope.questions[i].back_question_id = question_id;
					$scope.stepBack($scope.questions[i]);
					break;
				}
			}
		};

		$scope.backToStart = function () {
			$scope.situation_title = '';
			$scope.questions = $scope.default_questions;
			$scope.setDisplayStatus(0);
			$scope.id = 0;
			$scope.progressVal = 0;
			$scope.submited = false;
			$scope.formData = getDefaultData();
			$scope.back_to_question = false;
		};

		$scope.getCurrentQuestions = function (btn) {

			showResults(btn);
			if (typeof (btn.category) !== 'undefined') {
				$scope.formData.category = btn.category;
			}
			console.log($scope.formData);

		};

		var showResults = function (btn) {
			for (var i = 0, len = $scope.questions.length; i < len; i++) {
				if ($scope.questions[i].id == btn.question_id) {
					$scope.id = i;
					$scope.progressVal = $scope.questions[i].progress;
					break;
				}
			}

			//show list
			if (btn.question_id == 99) {
				if (typeof btn.back_question_id !== 'undefined' && btn.back_question_id > 0) {
					$scope.back_to_question = true;
					$scope.back_question_id = btn.back_question_id;
				} else {
					$scope.loading = false;
					$scope.resultsPage = true;
				}
				$scope.setDisplayStatus(btn.question_id);
			}

			fixView();

		};

		var fixView = function () {
			if (cont.offsetTop < window.scrollY) {
				window.scrollTo({
					top: cont.offsetTop - header.offsetHeight - 20,
					behavior: 'smooth' // Add smooth scrolling behavior
				});
			}
		};



		$scope.findAddress = function () {
			$scope.formData.address_id = null;
			console.log($scope.formData.address)
			if ($scope.findUrl !== '' && $scope.formData.address != '') {

				$scope.loading = true;
				$scope.show_bad_searches = false;
				$scope.clearAddressSugggests();

				ajaxSearch.search($scope.findUrl, {address: $scope.formData.address}).then(function (response) {
					if (response.success) {
						$scope.addresses = response.items;
						if ($scope.addresses.length > 0) {
							$scope.showSuggest = true;
							$scope.show_bad_searches = false;
						} else {
							$scope.addresses = [];
							$scope.messages = response.messages;
							/*$scope.number_bad_searches += 1;
							 if ($scope.number_bad_searches >= $scope.limit_bad_searches) {
							 $scope.show_bad_searches = true;
							 }*/
							if ($scope.formData.address != '' && $scope.formData.address.length >= $scope.bad_address_length) {
								$scope.show_bad_searches = true;
							}
						}
						$scope.loading = false;
					}
				}, function (response) {
					$log.error(response);
				});
			} else {
				$scope.clearAddressSugggests();
			}
		};

		$scope.setAddress = function (address) {
			$scope.formData.address_id = address._source.adr_id;
			$scope.formData.address = address._source.adr_sudetinis_adresas;
			$scope.formData.house = address._source.adr_vieta;
			$scope.formData.appartment = address._source.adr_patalpos_numeris;
			$scope.clearAddressSugggests();
		};

		$scope.clearAddressSugggests = function () {
			$scope.showSuggest = false;
			$scope.addresses = [];
			$scope.messages = [];
		};

		$scope.explicitlyTrustedHtml = function (text) {
			return $sce.trustAsHtml(text);
		}

//	$scope.isSetMandatoryAddress = function () {
//		if ($scope.formData.address === '' || $scope.formData.address_id === '') {
//			return false;
//		}
//		return true;
//	};
		$scope.isSetMandatoryAddress = function () {
			if ($scope.formParams.fields.address.active && $scope.formParams.fields.address.mandatory && (!$scope.formData.address_id || $scope.formData.address_id === '')) {
				return false;
			}
			return true;
		};

		$scope.isValid = function () {
			if (!$scope.isSetMandatoryAddress()) {
				return false;
			}
			return true;
		};

		$scope.submitForm = function (form) {
			$scope.trySubmit = true;
			if ($scope.isValid() && $scope.postUrl && $scope.postUrl !== '') {
				$scope.loading = true;
				if (typeof jsRegisterFault.recaptcha !== 'undefined') {
					grecaptcha.ready(function () {
						grecaptcha.execute(jsRegisterFault.recaptcha.siteKey, {action: 'submit'}).then(function (token) {
							$scope.formData.recaptchaResponse = token;
							$scope.submitFormPost(form);
						});
					});
				} else {
					$scope.submitFormPost(form);
				}
			} else {
				form.$submitted = false;
			}
		};

		$scope.submitFormPost = function (form) {
			$scope.messages = [];
			$http({
				method: 'POST',
				url: $scope.postUrl,
				data: getPostData()
			}).then(function (response) {
				if (response.data.success) {
					$scope.submited = true;
					form.$setPristine();
					form.$setUntouched();
					form.$submitted = false;
					fixView();
				} else {
					form.$submitted = false;
					if (typeof response.data.errors !== 'undefined' && response.data.errors.length > 0) {
						$scope.messages = response.data.errors;
					}
				}
			}).then(function () {
				$scope.loading = false;
			});
		};

		function getPostData() {
			var data = {};
			if (typeof jsRegisterFault.recaptcha !== 'undefined') {
				data[jsRegisterFault.recaptcha.field] = $scope.formData.recaptchaResponse;
			}
			for (var i in $scope.formParams.fields) {
				if ($scope.formParams.fields[i].active) {
					if (i === 'address') {
						data[i] = $scope.formData[i];
						data.address_id = $scope.formData.address_id;
						data.house = $scope.formData.house;
						data.appartment = $scope.formData.appartment;
					}
					/*else if(i === 'photo'){
					 data.photo = $scope.formData.files;
					 }*/
					else if (i === 'phone') {
						data.phone = '+370' + $scope.formData.phone;
					} else {
						data[i] = $scope.formData[i];
					}
				}
			}
			data.category = $scope.formData.category;
			return data;
		}

		$scope.onLastAnswerRender = function () {
			$scope.allAnswersRendered = true;
			$scope.$apply();
		};

		$scope.setFormDisplay = function () {
			$scope.displayStatus = 99;
		};

	}]).directive('onFinishRender', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			if (scope.$last === true) {
				element.ready(function () {
					scope.onLastAnswerRender();
				});
			}
		}
	};
}).directive('phonemask', function () {
	return {
		require: 'ngModel',
		link: function (scope, elem, attrs, ngModelCtrl) {
			scope.$watch(attrs.ngModel, function () {
				phone_pattern();
			});
		}
	};
});

